import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  SummaryCardHeader, SummaryCardOption, SummaryCardType
} from '@design-system/components/organisms/summary-card/entities/summary-card.types';
import { ImageSize } from '@design-system/components/molecules/image/entities/image.types';
import {
  TypographyFontFamily, TypographyFontSize, TypographyColor
} from '@design-system/components/atoms/typography/entities/typography.types';
import {
  ButtonLinkIconPosition, ButtonLinkType
} from '@design-system/components/molecules/button-link/entities/button-link.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { ImageDsComponent } from '@design-system/components/molecules/image/image.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';
import { ButtonLinkDsComponent } from '@design-system/components/molecules/button-link/button-link.component';

@Component({
  selector: 'app-ds-summary-card',
  templateUrl: './summary-card.component.html',
  styleUrls: ['./summary-card.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    ImageDsComponent,
    TypographyDsComponent,
    DividerDsComponent,
    ButtonLinkDsComponent,
  ]
})
export class SummaryCardDsComponent {

  @Input() type = SummaryCardType.Compacted;
  @Input() options: SummaryCardOption[] = [];
  @Input() header: SummaryCardHeader;
  @Input() title: string;
  @Input() image: string;

  @Output() headerEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly imageSize = ImageSize.None;

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;

  public readonly buttonLinkType = ButtonLinkType;
  public readonly buttonLinkIconPosition = ButtonLinkIconPosition;

  constructor() { }

  get titleFontSize(): TypographyFontSize {
    return this.type === SummaryCardType.Compacted ? TypographyFontSize.XXS : TypographyFontSize.XS;
  }

  public enabledIcon(option: SummaryCardOption): boolean {
    return this.type === SummaryCardType.Summarized && !!option.Icon;
  }

  public enabledTitle(option: SummaryCardOption): boolean {
    return (this.type !== SummaryCardType.Summarized && !!option.Title) || 
      (this.type === SummaryCardType.Summarized && !option.Icon)
  }

  public trackById(index: number): number {
    return index;
  }

}
